import { render } from "./TeoInfo.vue?vue&type=template&id=2f3df8b2"
const script = {}

import "./TeoInfo.vue?vue&type=style&index=0&id=2f3df8b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__